var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"b-innerlabel caption font-weight-bold white pa-2 grey--text text-lighten-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }